import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`As the Ethereum ecosystem continues to evolve, we continue to see exponential growth in the number of ERC20 tokens being issued. This maturation reflects the success of permissionless innovation, a trend we expect will only accelerate in the future: everything of value will be tokenized.`}</p>
    <p>{`As the rate of token issuance accelerates, it has become increasingly difficult for users to filter out high quality, legitimate tokens from scams, fakes, and duplicates.  Across the space, projects are managing and maintaining rapidly growing token lists. The end result is a lot of wasted time, slow listing processes and scammed users. In addition, builders should spend their time building, not deciding which tokens are legitimate and which are scams, fakes or duplicates.`}</p>
    <p>{`Today, we are excited to announce `}<a parentName="p" {...{
        "href": "https://tokenlists.org/"
      }}>{`Token Lists`}</a>{`, a new standard for creating lists of ERC20 tokens. This is a community-led initiative to improve discoverability and trust in ERC20 token lists in a manner that is inclusive, transparent, and decentralized.`}</p>
    <p>{`Token Lists follow a standard JSON schema and can be hosted publicly on ENS, IPFS, and HTTPS.`}</p>
    <p>{`The initial launch includes:`}</p>
    <ul>
      <li parentName="ul">{`An ERC20 token list standard`}</li>
      <li parentName="ul">{`A homepage and list browser at `}<a parentName="li" {...{
          "href": "https://tokenlists.org/"
        }}>{`tokenlists.org`}</a></li>
      <li parentName="ul">{`A community forum at `}<a parentName="li" {...{
          "href": "https://community.tokenlists.org/"
        }}>{`community.tokenlists.org`}</a></li>
      <li parentName="ul">{`Lists from `}<a parentName="li" {...{
          "href": "https://coinmarketcap.com/"
        }}>{`CoinMarketCap`}</a>{`, `}<a parentName="li" {...{
          "href": "https://www.coingecko.com/en"
        }}>{`Coingecko`}</a>{`, `}<a parentName="li" {...{
          "href": "https://www.dharma.io/"
        }}>{`Dharma`}</a>{`, `}<a parentName="li" {...{
          "href": "https://zerion.io/"
        }}>{`Zerion`}</a>{`, `}<a parentName="li" {...{
          "href": "https://kleros.io/"
        }}>{`Kleros TCR`}</a>{`, `}<a parentName="li" {...{
          "href": "https://defiprime.com/"
        }}>{`Defiprime`}</a>{`, `}<a parentName="li" {...{
          "href": "https://compound.finance/"
        }}>{`Compound`}</a>{`, `}<a parentName="li" {...{
          "href": "https://aave.com/"
        }}>{`Aave`}</a>{`, `}<a parentName="li" {...{
          "href": "https://synthetix.exchange/#/"
        }}>{`Synthetix`}</a>{`, `}<a parentName="li" {...{
          "href": "https://umaproject.org/"
        }}>{`UMA`}</a>{`, `}<a parentName="li" {...{
          "href": "https://1inch.exchange/#/"
        }}>{`1inch`}</a>{`, and `}<a parentName="li" {...{
          "href": "https://tryroll.com/"
        }}>{`Roll`}</a>{` (and many more coming soon!)`}</li>
    </ul>
    <p>{`Token Lists can be used `}<strong parentName="p">{`right now`}</strong>{` in the `}<a parentName="p" {...{
        "href": "https://app.uniswap.org/#/swap"
      }}>{`Uniswap Interface`}</a>{`, removing the need for a default list.`}</p>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/pAQyBRB8Y74" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <p>{`This is another step forward in interface decentralization. Read Uniswap Interface + IPFS to learn how the Uniswap interface is now hosted by the community in a decentralized manner.`}</p>
    <p>{`We hope to continue iterating and improving Token Lists in collaboration with the broader community.`}</p>
    <h2 {...{
      "id": "gatekeeping-is-dead",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#gatekeeping-is-dead",
        "aria-label": "gatekeeping is dead permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Gatekeeping is Dead`}</h2>
    <p>{`In the legacy financial system, the concept of “listing” is incredibly meaningful. Gatekeepers manage lists of assets on a discretionary basis. Without listing, the utility of an asset is severely diminished. Unlisted assets often can’t be transferred, traded or used in any other capacity. For all intents and purposes, “unlisted assets” do not exist.`}</p>
    <p>{`In the Ethereum-based decentralized financial system, the concept of “listing” loses its meaning. Anyone can create a new ERC20 token and transfer it to anyone else, and it will be publicly recorded on the Ethereum blockchain. `}</p>
    <p>{`Since all tokens use a standard interface, infrastructure-layer applications, such as wallets, analytics sites, and DeFi protocols (like Uniswap) can immediately recognize and interact with new ERC20 tokens from the moment they are deployed.`}</p>
    <p>{`Adding a new ERC20 token to the Uniswap protocol is as simple as calling a public function on a permissionless and immutable smart contract. In fact, about`}<strong parentName="p">{` 100 new Uniswap V2 liquidity pools are deployed every day`}</strong>{`, with over 6,000 pools added since it launched in May 2020.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {}
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1200px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a11f0dbe540aebc55fb8d51f4aa382be/1df5b/image1.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "37.99999999999999%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsSAAALEgHS3X78AAABNklEQVQoz4VS30sDMQy+//9/EEUfd+iD6Jg6lJ17cBMZh4L6oIgMpjvmmLdr0zb91h83d8LEQkjyJfmSpk3gjrVR/jrN2DabGahKhlIKiQ1oFG//Jz7PGAutN3XzGaP4ZE+NJHZwCWo76RrzObYeqfy2mE442NXS4jE3KD6iHwgVWSzmHIp9YXNirz0ByQ3uSR7uNJ7vDd5fDbrHCrNpg1BUXHeIBVJEkugDkzHj5cn8+OXC4rRFaKeEyxOFowPCV/FrQoRubqeh+6CnQ8HoJl5lmGmku4TsTGH8xsg6Cq0dQrpHONynEPN4IBRCOhKJ0UAivxXIh4SrdoXrc+kIKvS7XkvnC/Q6Thzm/XWsf1E5TGx2KISAlOT2xSBS9fJ13KfTxigIuayvyy5m6pdWQeuguf5GFisVwWVJKJFrvwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="a" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Uniswap pairs created per day",
              "title": "Uniswap pairs created per day",
              "src": "/static/a11f0dbe540aebc55fb8d51f4aa382be/c1b63/image1.png",
              "srcSet": ["/static/a11f0dbe540aebc55fb8d51f4aa382be/5a46d/image1.png 300w", "/static/a11f0dbe540aebc55fb8d51f4aa382be/0a47e/image1.png 600w", "/static/a11f0dbe540aebc55fb8d51f4aa382be/c1b63/image1.png 1200w", "/static/a11f0dbe540aebc55fb8d51f4aa382be/d61c2/image1.png 1800w", "/static/a11f0dbe540aebc55fb8d51f4aa382be/1df5b/image1.png 1999w"],
              "sizes": "(max-width: 1200px) 100vw, 1200px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Uniswap pairs created per day`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "decoupling-discovery--reputation-from-gatekeeping",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#decoupling-discovery--reputation-from-gatekeeping",
        "aria-label": "decoupling discovery  reputation from gatekeeping permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Decoupling Discovery + Reputation from Gatekeeping`}</h2>
    <p>{`While gatekeepers often stifle innovation, they also serve to filter out low quality assets that users don’t want or need.`}</p>
    <p>{`As we move towards mass tokenization, this process of filtering and curation becomes more important than ever before for Ethereum-based projects. The alternative is a UX nightmare, with users having to verify the legitimacy of assets on an ad hoc basis.`}</p>
    <p>{`As the decentralized finance movement continues to remove gatekeepers, it is imperative that new systems for discovery and reputation do not devolve into centralized gatekeeping. `}</p>
    <h2 {...{
      "id": "current-approaches",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#current-approaches",
        "aria-label": "current approaches permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Current Approaches`}</h2>
    <p>{`A naive approach to ERC20 token lists is automatically displaying every asset. While this is maximally decentralized, it opens up the door for phishing, scams, and presents users with way too many options.`}</p>
    <p>{`Another naive approach is creating a decentralized governance system as a gatekeeper, with the hope that this governance system will be fairer than the gatekeepers that came before it.`}</p>
    <p>{`Most projects opt for the easiest and most practical solution: maintaining a list supported by their own reputation. `}</p>
    <h2 {...{
      "id": "long-live-token-lists",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#long-live-token-lists",
        "aria-label": "long live token lists permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Long Live Token Lists`}</h2>
    <p>{`Token Lists leverages Ethereum’s greatest strengths - its numerous high quality projects and communities, their ability to share public infrastructure, and the ease of interoperability between them.`}</p>
    <p>{`The idea is simple - any project on Ethereum that maintains a list of ERC20 tokens hosts this list publicly following a standard JSON schema. Projects attach their reputation to lists by hosting them on a domain they control.`}</p>
    <p>{`Some examples:`}</p>
    <ul>
      <li parentName="ul">{`A list is hosted on test.cmc.eth, an ENS domain controlled by CoinMarketCap `}</li>
      <li parentName="ul">{`A list is hosted on Coingecko.com, which is controlled by CoinGecko`}</li>
      <li parentName="ul">{`A list is hosted on t2crtokens.eth, which is controlled by a Kleros TCR using a decentralised governance process`}</li>
    </ul>
    <p>{`Lists can also be project or category specific. For example:`}</p>
    <ul>
      <li parentName="ul">{`A personal tokens list by Roll`}</li>
      <li parentName="ul">{`A list of all Synthetix synths`}</li>
      <li parentName="ul">{`A list of all UMA synths`}</li>
    </ul>
    <p>{`Since lists are publicly hosted and follow a standard format, they can be decoupled from individual interfaces and instead be combined and shared across projects. For example, an interface could automatically display any tokens that are on at least m out of n reputable lists. Or it could display all tokens across a set of lists, but display trust scores based on the number lists an asset is on. Or it can build in a list explorer that allows any user to import the lists that they want to trust.`}</p>
    <p>{`Another critical advantage of lists is the speed at which new assets can be discovered and used. If a new asset is released by a reputable project, the project can simply update their own list and any interface (or aggregate list maintainer) subscribed to that list can automatically import it in real time.`}</p>
    <p>{`To help spur adoption of Token Lists and provide a high quality reference example, we have deprecated the old Uniswap interface “default list”, and replaced it with a list explorer and importing mechanism. `}</p>
    <p>{`We have also partnered with a number of reputable projects in the space who were excited to create and maintain lists of their own. More than 10 lists are already available on `}<a parentName="p" {...{
        "href": "https://tokenlists.org/"
      }}>{`tokenlists.org`}</a>{` and more are in progress.`}</p>
    <h2 {...{
      "id": "get-involved-with-token-lists",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#get-involved-with-token-lists",
        "aria-label": "get involved with token lists permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Get involved with Token Lists`}</h2>
    <p>{`We imagine Token Lists emerging as foundational infrastructure for the Ethereum ecosystem to self-govern reputation around tokens and are excited to see lists used in other projects.`}</p>
    <p>{`To get involved:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/uniswap/token-lists#authoring-token-lists"
        }}>{`Create a token list`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://community.tokenlists.org/"
        }}>{`Discuss token lists in the community forum`}</a></li>
      <li parentName="ul">{`Integrate Token Lists into your project`}</li>
      <li parentName="ul">{`Develop tooling or dashboards or help improve the dashboard we created`}</li>
      <li parentName="ul">{`Generate hype on crypto twitter`}</li>
    </ul>
    <p>{`Special thanks to Denis Nazarov and Jesse Walden for their help on this blogpost.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      